module.exports = __webpack_public_path__ + "media/images/front/medicines/pharmaceutical_search_ico-3ede8b8a0bc01e59e05bb2f786fab900.svg";